export const TRACKED_EVENT_POSITION = {
  NAV: 'nav',
  NAV_SUB: 'nav_sub',
  NAV_SITEMAP: 'nav_sitemap',
  MAIN_HEADER: 'main_header',
  MAIN_CONTENT: 'main_content',
  MAIN_CTA: 'main_cta',
  FOOTER: 'footer',
  MODAL: 'modal',
  // 블로그 상세 3단 레이아웃의 좌·우 레일. 구 `sidebar` 는 삭제된 사이드바 광고가
  // 쓰던 값이라 이어 쓰지 않는다 — 그대로 두면 GA 의 한 축에 광고 클릭과
  // 뉴스레터 구독이 이어 붙어 집계가 섞인다
  LEFT_SIDEBAR: 'left_sidebar',
  RIGHT_SIDEBAR: 'right_sidebar',
  BANNER: 'banner',
} as const;

export const TRACKED_EVENT_NAME = {
  CLICK_LINK: 'click_link',
  CLICK_BUTTON: 'click_button',
  CLICK_MAIL: 'click_mail',
  EXPERIMENT_VIEWED: 'experiment_viewed',
  CTA_CLICK: 'cta_click',
  FORM_INTERACTION: 'form_interaction',
  GENERATE_LEAD: 'generate_lead',
  GENERATE_MIDDLE_LEAD: 'generate_middle_lead',
  FORM_SUBMIT: 'form_submit',
  VIEW_ERROR_PAGE: 'view_error_page',
  SECTION_VIEW: 'section_view',
  CHANNEL_TALK: 'channel_talk',
} as const;

export type TrackedEventName =
  (typeof TRACKED_EVENT_NAME)[keyof typeof TRACKED_EVENT_NAME];

export interface TrackedEventProps {
  label: string;
  position: (typeof TRACKED_EVENT_POSITION)[keyof typeof TRACKED_EVENT_POSITION];
}

export interface TrackedEventOptions<
  T extends keyof TrackedEventProps | never = never,
> {
  gtagOptions?:
    | ({
        addGtag: true;
      } & ([T] extends [never]
        ? TrackedEventProps
        : Pick<TrackedEventProps, T>))
    | {
        addGtag?: false;
      };
}
